<template>
  <section class="hero hero-container">
    <img
        class="hero-container_headerImg"
        :src="stemExpoBannerImg()"
    />
    <div class="hero-container_box">
      <span class="hero-container_box_underline"/>
      <div class="hero-container_box_text">
        <h1 class="hero-container_box_header">{{ stemExpoTitle() }}</h1>
        <p style="font-size: 0.625rem;">{{ stemExpoContent() }}</p>
      </div>
      <span class="hero-container_box_underline"/>
      <div class="hero-container_dropbox">
        <Dropdown
          id="type"
          env="Ysc"
          :path="this.$route.path"
          v-model="stemExpoProject"
          :items="stemExpoProjects"
        />
      </div>
    </div>
  </section>
</template>
<script>
import projects from '@/api/projects'
import Dropdown from '@/components/Controls/GenericComponents/dropdown'

import i18n from '@/i18n'

export default {
  components: {
    Dropdown
  },
  data: function () {
    return {
      stemExpoProject: this.$i18n.t('stemexpo.dropdown'),
      stemExpoProjects: [],
      stemBannerBoothEn: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ysc%2Fstem-expo-banner%2Fstem-expo-banner-en.png?alt=media&token=cc019260-ac58-485d-a15b-4634f4040484',
      stemBannerBoothFr: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ysc%2Fstem-expo-banner%2Fstem-expo-banner-fr.png?alt=media&token=1857f6f2-5314-46ea-b241-f5311a59f5be',
      stemBannerMobile: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ysc-cwsf-2022%2Fbanner-mobile-1ef200c0-d1cd-11ec-a36d-0d497d00b99c?alt=media&token=6e9e1c27-3b35-4e8d-829d-09b1b536d40c'
    }
  },
  mounted: function () {
    this.getPartners()
  },
  methods: {
    isMobile () {
      if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    stemExpoBannerImg: function () {
      if (this.isMobile()) {
        return this.stemBannerMobile
      } else if (this.$i18n.locale === 'fr') {
        return this.stemBannerBoothFr
      } else {
        return this.stemBannerBoothEn
      }
    },
    stemExpoTitle: function () {
      return i18n.t('stemexpo.title')
    },
    stemExpoContent: function () {
      return i18n.t('stemexpo.description')
    },
    Comparator: function (a, b) {
      if (a[1] < b[1]) return -1
      if (a[1] > b[1]) return 1
      return 0
    },
    customSortAndLanguageInsert: function (array) {
      var final = []

      let i = 0
      const arrayLength = array.length
      while (i < arrayLength) {
        const temp = array[i]
        if (temp.user && temp.user.fullName) {
          final.push([i, temp.user.fullName.toUpperCase()])
        } else if (temp.user) {
          final.push([i, temp.user.userName.toUpperCase()])
        } else {
          final.push([i, temp.title.toUpperCase()])
        }
        i++
      }

      final.sort(this.Comparator)
      const toReturn = []

      let z = 0
      while (z < arrayLength) {
        const temp1 = final[z]
        const toAdd = temp1[0]
        const editStart = array[toAdd]
        if (editStart.sourceProjectID === 72535 || editStart.sourceProjectID === 79190) {
          editStart.user.userName = editStart.user.userName.concat(' ', '(EN)')
          if (editStart.user.fullName.length > 0) {
            editStart.user.fullName = editStart.user.fullName.concat(' ', '(EN)')
          }
        } else if (editStart.sourceProjectID === 72538 || editStart.sourceProjectID === 79197) {
          editStart.user.userName = editStart.user.userName.concat(' ', '(FR)')
          if (editStart.user.fullName.length > 0) {
            editStart.user.fullName = editStart.user.fullName.concat(' ', '(FR)')
          }
        }
        toReturn.push(editStart)
        z++
      }
      return toReturn
    },
    getPartners: function () {
      this.error = this.error || ''
      projects.getByTemplateIDs('[72535,79190,72538,79197]', 100).then((response) => {
        const dropdownContent = response.data.result.projects
        this.stemExpoProjects = this.customSortAndLanguageInsert(dropdownContent)
      }, (error) => {
        this.error = error.message
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~styles/utils.scss';

.language-white-background {
  background: white;
}

.home-section {
  z-index: -12;
  background-color: var(--background-fifth);
  padding-top: 1rem;
  min-height: calc(100vh - #{$navbar-height});
}

.hero-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  width: 100%;
  max-height: 500px;
  height: 360px;
  background-image: url('https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/yscResources%2Fstem_expo_curtain_bg.png?alt=media&token=0bbf9151-e10a-4c32-bbf9-48033b9d678d');
  background-size: 1000px 400px !important;
  background-repeat: repeat !important;
  background-position: bottom !important;

  &_button {
    position: absolute;
    left: 0;
    margin: 2rem;
    border: none;
    background: transparent;
    cursor: pointer;
    text-transform: uppercase;
  }
  @include mobile {
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    height: 350px;
  }

  @include tablet {
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  &_dropbox {;
    padding-top: 1.5rem !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @include tablet {
      padding-top: .5rem;
    }
  }
  &_headerImg {
    max-height: 415px;
    position: absolute;
    @include tablet {
      padding-top: 1rem;
    }
    @include mobile {
      height: 100%;
      position: relative;
    }
  }

  &_box {
    position: absolute;
    top: 10rem;
    width: 17rem;
    color: white;
    @include mobile {
      top: 7rem !important;
    }

    &_underline {
      height: 3px;
      width: 80px;
      background-color: #00ADEE;
      position: absolute;
      margin:0 auto;
      left: 33%;
      @include mobile {
        left: 30%;
      }
    }

    &_text {
      padding: .5rem 0;
    }

    &_header {
      text-transform: uppercase;
      font-size: 2rem;
      text-align: center;

      @include mobile {
        font-size: 1.5rem;
      }
    }

    @include mobile {
      color: white;
      top: 10rem;
      width: 12rem;
    }
  }
}

.ad-container {
  display: flex;
  align-content: center;
  justify-content: center;
}

.sort-container {
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  padding: 2.5rem 1.37rem 0 2.3rem;
}

.sort-container.title-and-sort {
  justify-content: space-between;
}

.select {
  font-size: 1rem;
  margin-top: 0.5rem;
}

.option {
  font-size: 0.9rem;
  min-height: 0;
}

.projects-container {
  padding-left: 1.3rem;
  padding-bottom: 7rem;
&.filtered-projects-container {
   padding-left: 0;
 }
&.stories {
   max-width: 100%;
   width: 100%;
   padding-left: 1.3rem;
 }
}

.current-title {
  padding-right: 1.5rem;
  text-align: center;
  text-transform: capitalize;
}

.ieFix {
  min-width: 16rem;
  min-height: 16.5rem;
  margin: 1rem 1.7rem;
}

.all-categories {
  margin-bottom: 1rem;
}

.interests {
  position: static;
  margin: 2.2rem 0 3rem 1.5rem;
  align-items: center;
  justify-content: flex-start;
  position: static;
  .interests-title {
    position: static;
    font-size: 1.7rem;
    font-weight: 600;
    margin-right: 1.5rem;
    color: #000;
  }
  img {
    width: 55px;
    height: 55px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    margin-left: 0.8rem;
  }
}

// PERSONALIZE BUTTON STYLES
.personalize-button-margin {
 margin-left: 2rem;
  @include mobile {
    margin-left: 0;
  }
}
.remove-margin {
  margin-left: 0;
}
.personalize-button-container {
  display: flex;
  justify-content: center;
  margin: 2rem 0;
}

.category-image {
  justify-content: flex-end;
  align-items: flex-end;
  position: relative;
}

.not-found {
  padding: 4rem 0;
  text-align: center;
}

.no-boards-message {
  text-align: center;
  padding-top: 2.3rem;
a {
  font-weight: 700;
}
}

@include tablet-only {
  .projects-container {
&.stories {
   padding-left: 0.69rem
 }
}
}

@include mobile {
  .sort-container {
    padding: 2rem 1rem 0;
  }
  .select {
    font-size: 0.8rem;
  }
  .option {
    font-size: 0.6rem;
  }
  .projects-container {
    padding-left: 0.75rem;
&.filtered-projects-container {
   padding-left: 0.75rem;
 }
&.stories {
   padding-left: 0.69rem
 }
}
.current-title {
  width: 100%;
  text-align: left;
  line-height: 1.25;
}
.all-categories-title {
  margin-top: 0.5rem;
}
.interests {
  margin: 0.7rem 0;
  flex-direction: column;
.interests-title {
  margin-right: 0;
  margin-bottom: 1.5rem;
}
}
.no-boards-message {
  padding-right: 0.69rem
}
}

@include mini-mobile {
  .sort-container {
    padding: 1rem 0.75rem 0;
  }
}
.user-tags {
  justify-content: flex-start;
  flex-wrap: wrap;
}
.tag {
  margin: 0.15rem 0.3rem 0.15rem 0;
  font-size: 0.8rem;
  margin-bottom: 0.3rem;
  color: $grey-dark;
  background-color: $white;
  border-radius: 2px;
  border: 1px solid $grey-light;
}
</style>
